import * as React from 'react'

const SvgWallet = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      fill="none"
      viewBox="0 0 17 16"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M14 6.333V4.8c0-.747 0-1.12-.145-1.405a1.334 1.334 0 00-.583-.583c-.285-.145-.659-.145-1.405-.145H4.133c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583C2 3.68 2 4.053 2 4.8v6.4c0 .747 0 1.12.145 1.405.128.251.332.455.583.583.285.145.659.145 1.405.145h7.734c.746 0 1.12 0 1.405-.145.25-.128.455-.332.583-.583C14 12.32 14 11.947 14 11.2V9.667M10.667 8c0-.31 0-.465.025-.593a1.333 1.333 0 011.048-1.048c.129-.026.284-.026.593-.026h1.334c.31 0 .464 0 .593.026.529.105.943.519 1.048 1.048.025.128.025.283.025.593s0 .465-.025.593a1.333 1.333 0 01-1.048 1.048c-.129.026-.284.026-.593.026h-1.334c-.31 0-.464 0-.593-.026a1.333 1.333 0 01-1.048-1.048c-.025-.128-.025-.283-.025-.593z"
      ></path>
    </svg>
  )
}

export default SvgWallet
